import { BatchFlightUpload } from "@/components/admin/BatchFlightUpload";

export default function UploadSchedulePage() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Flight Schedule Upload</h2>
        <p className="text-muted-foreground">Upload CSV files for flight data</p>
      </div>
      <BatchFlightUpload />
    </div>
  );
}
